import TableCustomUi from '@ui/tableCustom/view/ui/tableCustomUi/TableCustomUi';
import React, {ReactNode} from 'react';
import {useMedia} from "@hooks/ui/useMedia";

interface IProps{
    stickyHeader:boolean,
    maxHeightScreen?:string,
    children:ReactNode
}
const TableCustomUiComponent = ({
                                    stickyHeader,
                                    maxHeightScreen,
                                    children
}:IProps) => {
    const {isDesktop} = useMedia()


    return (
        <TableCustomUi
            stickyHeader={stickyHeader}
            className={'customTableContainer'}
            sxContainer={{
                ...((stickyHeader) && isDesktop ? {
                    maxHeight: maxHeightScreen,
                    overflowY: 'auto'
                } : {}),
            }}
        >
            {children}
        </TableCustomUi>
    );
};

export default TableCustomUiComponent;